module.exports = __webpack_public_path__ + "img/82ba641.jpg";